import { render, staticRenderFns } from "./PriceSetDrawer.vue?vue&type=template&id=01a40470&scoped=true"
import script from "./PriceSetDrawer.vue?vue&type=script&lang=js"
export * from "./PriceSetDrawer.vue?vue&type=script&lang=js"
import style0 from "./PriceSetDrawer.vue?vue&type=style&index=0&id=01a40470&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a40470",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01a40470')) {
      api.createRecord('01a40470', component.options)
    } else {
      api.reload('01a40470', component.options)
    }
    module.hot.accept("./PriceSetDrawer.vue?vue&type=template&id=01a40470&scoped=true", function () {
      api.rerender('01a40470', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/drawer/PriceSetDrawer.vue"
export default component.exports